import React, { useMemo, useState } from "react";
import PT from "prop-types";
import * as S from "./styled";
import EyeOpenIcon from "_c/icon/EyeOpen";
import EyeClosedIcon from "_c/icon/EyeClosed";
import ServicePrice from "./ServicePrice";
import { SEARCH_NS as ns } from "@/i18n/ns";

const TO_SHOW = 3;
const MasterServices = (props) => {
  const [show, setShow] = useState(false);
  const excerpt = useMemo(() => {
    if (props.services.length > TO_SHOW) {
      return props.services.slice(0, TO_SHOW);
    }
    return props.services;
  }, [props.services]);
  const list = show ? props.services : excerpt;
  return (
    <S.Wrap>
      {list.map((service) => (
        <S.Service key={service._id}>
          <span>{service.title}</span>
          <ServicePrice service={service} />
        </S.Service>
      ))}
      {props.services.length > TO_SHOW && (
        <S.ShowBtn onClick={() => setShow(!show)}>
          {show ? (
            <EyeClosedIcon color="white" width="18" />
          ) : (
            <EyeOpenIcon color="white" width="18" />
          )}
          <span>
            {props.t(`${ns}:${show ? "hide_services" : "show_services"}`)}
          </span>
        </S.ShowBtn>
      )}
    </S.Wrap>
  );
};
MasterServices.propTypes = {
  services: PT.array,

  t: PT.func.isRequired,
};

export default MasterServices;
